import { Button } from 'devextreme-react/button';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import { useContext, useState } from 'react';
import { FileTypes, KindOfOrder } from '../../../../types/enums';
import { FileAttachmentLink, FileAttachmentsPopup } from '../../../common';
import { PurchaseOrderContext, RefetchScope } from '../../purchase-order/context/PurchaseOrderContext';

export default function CreditMemoFiles() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<>
				{
					<>
						<Toolbar className='button-toolbar'>
							<Item location={'before'} >
								<Button
									text="Upload Credit Memo"
									icon="Inscyth-Add"
									width={220} onClick={() => setPopupVisibility(true)}>
								</Button>
							</Item>
						</Toolbar>

						<FileAttachmentsPopup
							attachedFiles={order.details.files.filter(x => x.fileTypeID === FileTypes.CreditMemo)}
							orderID={order.details.purchaseOrderID}
							parentGuid={order.details.guid}
							kindOfOrder={KindOfOrder.PurchaseOrder}
							defaultFileType={FileTypes.CreditMemo}
							useFileTypes={false}
							onFileAdded={(fileType: FileTypes) => {
								refetchOrder(RefetchScope.Files);

								if (fileType === FileTypes.CreditMemo) {
									setPopupVisibility(false);
								}
							}}
							onFileDeleted={() => refetchOrder(RefetchScope.Files)}
							onPopupHidden={() => setPopupVisibility(false)}
							visible={isPopupVisible}
						/>
					</>
				}
			</>

			{
				order.details.files.some(x => x.fileTypeID === FileTypes.CreditMemo) &&
				<DataGrid
					className='dx-card wide-card'
					dataSource={order.details.files.filter(x => x.fileTypeID === FileTypes.CreditMemo)}
					allowColumnResizing={true}
					showBorders={true}
					showColumnLines={true}
					columnAutoWidth={true}
					keyExpr={'documentID'}
				>
					<Paging enabled={false} />

					<Column
						caption={'File Name'}
						dataType="string"
						cellRender={(cell: any) => {
							return <FileAttachmentLink
								caption={cell.data.fileName}
								fileName={cell.data.fileName}
								awsS3Key={cell.data.awsS3Key} />
						}}
					>
					</Column>
					<Column
						dataField={'fileTypeName'}
						caption={'File Type'}
						dataType="string"
					/>
					<Column
						dataField={'uploadDate'}
						caption={'Upload Date'}
						dataType="date"
						format="shortDateShortTime"
					/>
					<Column
						dataField={'createdBy'}
						caption={'Created By'}
						dataType="string"
					/>
				</DataGrid>
			}
		</>
	);
}
